import React, { useState } from "react";
import { Card, CardBody, Col, Container, CardHeader, Row } from "reactstrap";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ExportCSVModal from "../../Components/Common/ExportCSVModal";
import { useProfile } from "../../Components/Hooks/UserHooks";
import ContractTable from "./ContractTable";
import ContractModal from "./ContractModal/ContractModal";
import BreadCrumb from "../../Components/Common/BreadCrumb";

const ContractsManegement = () => {
  const [contractModal, setContractModal] = useState(false);

  const handleContractModal = () => {
    setContractModal(true);
  };

  const { userProfile, isAdmin, isEditor } = useProfile();

  const [isExportCSV, setIsExportCSV] = useState(false);

  return (
      <React.Fragment>
        <div className="page-content">
          <ToastContainer closeButton={false} limit={1} />
          <ExportCSVModal
              show={isExportCSV}
              onCloseClick={() => setIsExportCSV(false)}
              data={"null"}
          />

          {contractModal && (
              <ContractModal
                  show={contractModal}
                  onCloseClick={() => setContractModal(false)}
              />
          )}

          <Container fluid>
            <BreadCrumb title="Contracts" pageTitle="Clients" />
            <Row>
              <Col lg={12}>
                <Card id="orderList">
                  <CardHeader className="border-0">
                    <Row className="align-items-center gy-3">
                      <div className="col-sm">
                        <h5 className="card-title mb-0">Contracts</h5>
                      </div>
                      <div
                          className="col-sm-auto"
                          style={{ marginBottom: "10px" }}
                      >
                        <div className="d-flex gap-1 flex-wrap">
                          {(isAdmin || isEditor) && (
                              <>
                                <button
                                    type="button"
                                    className="btn btn-success add-btn"
                                    id="create-btn"
                                    onClick={handleContractModal}
                                >
                                  <i className="ri-add-line align-bottom me-1"></i>{" "}
                                  Create Contract
                                </button>
                              </>
                          )}
                          <button
                              type="button"
                              className="btn btn-info"
                              onClick={() => setIsExportCSV(true)}
                          >
                            <i className="ri-file-download-line align-bottom me-1"></i>{" "}
                            Export
                          </button>
                        </div>
                      </div>
                    </Row>
                  </CardHeader>
                  <CardBody className="pt-0">
                    <ContractTable />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
  );
};

export default ContractsManegement;
